import { serviceHelper } from '../utils/serviceHelper'

export const sendSolicitation = async (solicitationData) => {
  try {
    const partnerApi = getAxiosCreate()
    const solicitation = await partnerApi.post('/professional-solicitations', solicitationData)
    return solicitation
  } catch (err) {
    return err.response.data
  }
}

export const updateSolicitation = async (solicitationId, solicitationData) => {
  const partnerApi = getAxiosCreate()
  const solicitation = await partnerApi.put(`/professional-solicitations/${solicitationId}`, solicitationData)
  return solicitation
}

export const getSolicitations = async (professionalId) => {
  const partnerApi = getAxiosCreate()
  const solicitations = await partnerApi.get(`/professional-solicitations?professionalId=${professionalId}`)
  return solicitations.data
}

export const getSolicitationsHistory = async ({ professionalId, partnerId, kind, skip, limit, dateStart, dateEnd }) => {
  const partnerApi = getAxiosCreate()
  const solicitationsHistory = await partnerApi.get('professional-solicitations/filters', {
    params: {
      professionalId,
      partnerId,
      kind,
      skip,
      limit,
      dateStart,
      dateEnd
    }
  })
  return solicitationsHistory.data
}

const getAxiosCreate = () => {
  return serviceHelper.createApiClient(`${process.env.REACT_APP_PARTNER_URL}`)
}
